<template>
  <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div>
  <form @submit.prevent="handleFilters">
    <div class="row filter-row">
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocused }"
        >
          <input
            type="text"
            class="form-control floating"
            v-model="filters.employee_id"
            @focus="isFocused = true"
            @blur="isFocused = employee_id !== ''"
          />
          <label class="focus-label">Employee ID</label>
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocusedOn }"
        >
          <input
            type="text"
            class="form-control floating"
            v-model="filters.employee_name"
            @focus="isFocusedOn = true"
            @blur="isFocusedOn = employee_name !== ''"
          />
          <label class="focus-label">Employee Name</label>
        </div>
      </div>
      <div v-if="isRaise" class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="statuses"
            v-model="filters.status"
            placeholder="Select Status"
            id="design3"
          />
          <label class="focus-label">Status</label>
        </div>
        <i
          v-if="filters.status"
          @click="handleClearOneFilter('status')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div :class="isRaise ? 'col-md-3' : 'col-md-5'"></div>
      <div class="d-flex col-sm-6 col-md-3 gap-2">
        <button
          type="submit"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="handleFilters"
        >
          Search
        </button>
        <button
          type="button"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="resetAllFilters"
        >
          Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { boolean } from 'yup';

export default {
  props: {
    isRaise: {
      type: boolean,
      default: false,
    }
  },
  data() {
    return {
      select2: null,
      isFocused: false,
      filters: {
        employee_id: "",
        employee_name: "",
        status: "",
      },
      statuses: ['Approved', 'Pending', 'Rejected'],
      isFocusedOn: false,
      searched: false,
    };
  },
  methods: {
    handleFilters(value) {
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      const cleanedFilters = Object.fromEntries(
        Object.entries(this.filters).filter(([key, value]) => value !== "")
      );
      this.$emit("apply-filters", cleanedFilters);
      // Perform any action on change
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      //   Object.keys(this.filters).forEach(key => {
      //     this.filters[key] = "";
      //   });
      this.filters = [];
      // Emit updated filters
      this.$emit("apply-filters", this.filters);

      // Reset search state
      this.searched = false;
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        employee_id: "",
        employee_name: "",
        status: "",
      };
      this.searched = false;
    },
  },
  async created() {
    this.searched = false;
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>
